module.exports = __webpack_public_path__ + "static/img/ios5.55544710.jpg";